import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import MainProfileCard from '../components/MainProfileCard';
import { Oval, Triangle } from 'react-loader-spinner';
import { fetchUserDetails, updateUserStatus } from '../redux/UsersSlice';
import AboutSection from '../components/AboutSection';
import ExperienceSection from '../components/ExperienceSection';
import EducationSection from '../components/EducationSection';
import SkillsSection from '../components/SkillsSection';
import InterestsSection from '../components/InterestsSection';
import PublicationsSection from '../components/PublicationsSection';

const UserDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { slug } = useParams();
  const { selectedUser: user, loading } = useSelector(state => state.users);
  const [isUpdating, setIsUpdating] = useState(false);


  useEffect(() => {
    if (slug) {
      dispatch(fetchUserDetails(slug));
    }
  }, [dispatch, slug]);

  const handleStatusUpdate = async (newStatus) => {
    try {
      setIsUpdating(true);
      const result = await dispatch(updateUserStatus({
        userId: user.id,
        status: newStatus
      })).unwrap();

      toast.success(`User ${newStatus === 'active' ? 'activated' : 'deactivated'} successfully`);
      // Refresh user details to get updated data
      dispatch(fetchUserDetails(slug));
    } catch (error) {
      toast.error(`Failed to update user status`);
    } finally {
      setIsUpdating(false);
    }
  };



  if (loading) {
    return (
        <div className="flex justify-center items-center h-screen">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
        </div>
    )
}

    // if (error) {
    //   return <div>Error: {error}</div>;
    // }

  return (
    <div className='grid grid-cols-1 gap-4 lg:mx-20 my-6'>
       <div className="mb-4">
                <button
                    onClick={() => navigate(-1)}
                    className="hover:underline"
                >
                    Go back
                </button>
            </div>
      <div>
        {user?.status === 'active' ? (
          <button
            onClick={() => handleStatusUpdate('inactive')}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
          >
            {isUpdating ? (
              <div className=" flex justify-center items-center">
                <Oval
                  visible={true}
                  height="20"
                  width="20"
                  color="#ffff"
                  ariaLabel="oval-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            ) : 'Block User'}
          </button>
        ) : (
          <button
            onClick={() => handleStatusUpdate('active')}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
          >
            {isUpdating ? (
              <div className=" flex justify-center items-center">
                <Oval
                  visible={true}
                  height="20"
                  width="20"
                  color="#ffff"
                  ariaLabel="oval-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            ) : 'Activate User'}
          </button>
        )}
      </div>
      <div className=''>
        <MainProfileCard profileData={user} />
        <AboutSection user={user} />
        <ExperienceSection user={user} />
        <EducationSection user={user} />
        <SkillsSection user={user} />
        <InterestsSection user={user} />
        <PublicationsSection user={user} />
      </div>

    </div>
  );
};

export default UserDetail;